import { filter, find, findIndex, remove } from 'lodash'

const getPageData = () => {
  if (window.pageData.catalogDetails !== undefined) {
    return window.pageData.catalogDetails
  } else if (window.pageData.catalogMix !== undefined) {
    return window.pageData.catalogMix
  } else {
    throw Error('Could not find catalog page data')
  }
}

const pageData = getPageData()

export default {
  state: {
    allowCropping: pageData.allowCropping,
    allowRetouching: pageData.allowRetouching,
    alwaysShowRetouchingModal: pageData.alwaysShowRetouchingModal,
    catalogListUrl: pageData.catalogListUrl,
    cropPhotoModalModuleContent: pageData.cropPhotoModalModuleContent,
    currency: pageData.currency,
    currentCultureNumberFormat: window.pageData.currentCultureNumberFormat,
    customerInfo: pageData.customerInfo,
    firstOptionProduct: pageData.firstOptionProduct,
    howToOrderContent: pageData.howToOrderContent,
    howToOrderViewModel: pageData.howToOrderViewModel,
    offerPackage: pageData.offerPackage,
    packageConfig: pageData.packageConfig,
    packageDetailsViewModel: pageData.packageDetailsViewModel,
    packageQuantity: 1,
    promoBanner: pageData.promoBanner,
    selectDifferentPhotoViewModel: pageData.selectDifferentPhotoViewModel,
    selectPhotoModalContent: pageData.selectPhotoModalModuleContent,
    selectedRetouchings: [],
    siteRoot: window.pageData.siteRoot,
    zoomModalModuleContent: pageData.zoomModalModuleContent
  },
  mutations: {
    resetSelectedRetouchings: (state) => {
      state.selectedRetouchings = []
    },
    updateSelectedRetouchings: (state, data) => {
      state.selectedRetouchings = data
    },
    addSelectedRetouching: (state, data) => {
      state.selectedRetouchings.push(data)
    },
    removeSelectedRetouching: (state, data) => {
      remove(state.selectedRetouchings, (selectedRetouching) => {
        return selectedRetouching.frameId === parseInt(data.frameId, 10) && selectedRetouching.offerPackageId === parseInt(data.offerPackageId, 10)
      })

      state.selectedRetouchings = [...state.selectedRetouchings]
    },
    toggleAlwaysShowRetouchingModal: (state, value) => {
      window.localStorage.setItem('alwaysShowRetouchingModal', value.toString())
      state.alwaysShowRetouchingModal = value
    },
    frameCropped: (state, data) => {
      let eventFrameIndex = findIndex(state.selectDifferentPhotoViewModel.EventFrames, { FrameID: data })
      let favoriteFrameIndex = findIndex(state.selectDifferentPhotoViewModel.FavoriteFrames, { FrameID: data })

      if (eventFrameIndex > -1) {
        state.selectDifferentPhotoViewModel.EventFrames[eventFrameIndex].IsCropped = true
      }

      if (favoriteFrameIndex > -1) {
        state.selectDifferentPhotoViewModel.FavoriteFrames[favoriteFrameIndex].IsCropped = true
      }
    },
    updatePackageQuantity: (state, newQuantity) => {
      state.packageQuantity = newQuantity
    }
  },
  getters: {
    getFrame: state => frameId => {
      // ignoring getting the frame from selectDifferentPhotoViewModel.FavoriteFrames for now. don't think it's used
      return find(state.selectDifferentPhotoViewModel.EventFrames, { FrameID: frameId })
    },
    selectedRetouchingsByFrame: state => frameId => {
      return filter(state.selectedRetouchings, sr => {
        return sr.frameId === frameId
      })
    },
    getConfiguredValue: state => (formInputName, catalogPackageOptionProductId = null) => {
      if (state.packageConfig === null) return null

      let configValue

      if (catalogPackageOptionProductId === null) {
        configValue = find(state.packageConfig.Config, { Key: formInputName })
      } else {
        configValue = find(state.packageConfig.Config, { Key: formInputName, Value: catalogPackageOptionProductId.toString() })
      }

      return (configValue !== undefined) ? configValue.Value : null
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/stores/catalogPageCommon.js